import { SupportRecommendedArticles } from "./SupportRecommendedArticles";
import { useFetchSupportArticles } from "@core/features/support";

export type Props = {
  programId?: string;
};

export function SupportRecommendedArticlesContainer({ programId }: Props) {
  const { data } = useFetchSupportArticles(programId);
  const articles = data?.articles ?? [];
  const categories = data?.categories ?? [];

  if (articles.length === 0) {
    return null;
  }

  return <SupportRecommendedArticles categories={categories} />;
}

export default SupportRecommendedArticlesContainer;

